import React from 'react'
import ForcastModule from '../Forcast/ForcastModule'
import WeatherComponent from '../Graphs/WeatherComponent';


const RightBoard = () => {


  return (
    <div>
      <ForcastModule />
      <WeatherComponent />
    </div>
  )
}

export default RightBoard